// extracted by mini-css-extract-plugin
module.exports = {"dictionary-connections":"dictionary-connections___2Us5C"};